import Vue from 'vue';
import store from './../../store';

// When the request succeeds
const successDeleteUser = (cbInfo, response) => {
  // console.log('get users OK response:');
  // console.log(response.data);
  if (response.status === 200 || response.status === 201) {
    store.dispatch('getUser', response.data);
  }
  if (cbInfo && cbInfo.cbSuccess) {
    cbInfo.cbSuccess(response);
  }
};

// When the request fails
const failedDeleteUser = (cbInfo, response) => {
  // console.log('get users error response:');
  // console.log(response);
  if (response.status === 304) {
    if (cbInfo && cbInfo.cbSuccess) {
      cbInfo.cbSuccess(response);
    }
    return;
  }
  if (cbInfo && cbInfo.cbFail) {
    cbInfo.cbFail(response);
  }
};

export default (spid, userid, cbInfo) => {
  const axiosOptions = {
    timeout: 10000,
    headers: { 'X-Auth-Token': localStorage.getItem('jwt') },
    maxRedirects: 0,
    withCredentials: false,
  };
  const thisurl = `/api/v1/sp/${spid}/user/${userid}`;
  Vue.$http.delete(thisurl, axiosOptions)
   .then((response) => {
     successDeleteUser(cbInfo, response);
   })
   .catch((error) => {
     failedDeleteUser(cbInfo, error);
   });
};



// WEBPACK FOOTER //
// ./src/app/services/account/delcustomeruser.js